export const selectColumnListSoftSkillsTable = [
  { optionKey: "Select Column", optionValue: "" },
  { optionKey: "Id", optionValue: "id" },
  { optionKey: "Soft Skill", optionValue: "name" },
  { optionKey: "Description", optionValue: "description" },
];

export const sortByOptionSoftSkillsTable = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Sort Ascending", optionValue: "asc" },
  { optionKey: "Sort Descending", optionValue: "dsc" },
];
